import { render } from "./TransactionLogDetail.vue?vue&type=template&id=00dc78fe"
import script from "./TransactionLogDetail.vue?vue&type=script&lang=js"
export * from "./TransactionLogDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__